module.exports = __webpack_public_path__ + "static/adenilda-2f225c7ba06afe93828a56c893ef4e38.jpg";